import React, { useContext, useState } from 'react';
import { connect } from 'react-redux';
import ReusableButton from './../button';
import CartContext from './cartContext';
import CartProduct from './cartProduct';
import Checkout from './checkout';
import './index.css';

const Cart = ({ classes, ...props }) => {
    const { cartProducts } = props;
    const handleCartIconClick = useContext(CartContext);

    return (
        <div className={`off-canvas py-4 px-2 text-white bg-dark ${classes.cart}`}>
            <span
                className="cart-close-btn"
                onClick={handleCartIconClick}
            >X</span>
            <div className="cart-products overflow-auto">
                {
                    cartProducts.length ?
                        <ul>
                            {
                                cartProducts.map((p, i) => {
                                    return (
                                        <CartProduct product={p} key={i} />
                                    );
                                })
                            }
                        </ul> : 'No products in your cart'
                }
            </div>
            <Checkout cartProducts={cartProducts}/>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        cartProducts: state.cartProducts
    }
}

export default connect(mapStateToProps)(Cart);